export default "__VITE_ASSET__CFe_TwBo__"